import { routes as home } from '../pages/home'
import { routes as product_list } from '../pages/product_list'
import { routes as product_car_list } from '../pages/product_car_list'
import { routes as product_detail } from '../pages/product_detail'
import { routes as pre_cart } from '../pages/pre_cart'
import { routes as delivery } from '../pages/delivery'
import { routes as payment } from '../pages/payment'
import { routes as finish_order } from '../pages/finish_order'
import { routes as acompanhar_pedido } from '../pages/acompanhar_pedido'
import { routes as add_adress } from '../pages/add_adress'
import { routes as add_car } from '../pages/add_car'
import { routes as invite_friend } from '../pages/invite_friend'
import { routes as cart_checkout } from '../pages/cart_checkout'
import { routes as register } from '../pages/register'
import { routes as auth } from '../modules/auth'


export default [
  ...auth,
  ...home,
  ...register,
  ...product_list,
  ...product_car_list,
  ...product_detail,
  ...pre_cart,
  ...delivery,
  ...payment,
  ...finish_order,
  ...acompanhar_pedido,
  ...add_adress,
  ...add_car,
  ...invite_friend,
  ...cart_checkout,
]
